import { stashInvitationTokenFromUrl } from './invitationToken';

stashInvitationTokenFromUrl();
